if ($('.type-detail').length) {


function getActiveSku() {
    var variantData =
        typeof shoptet !== 'undefined' &&
        shoptet.variantsSplit &&
        shoptet.variantsSplit.necessaryVariantData
            ? shoptet.variantsSplit.necessaryVariantData
            : null;

    if (variantData) {
        /*
         * 1. Standardní případ:
         * Shoptet zobrazí aktivní .parameter-dependent
         * s třídou například "14-23240".
         */
        var $visible = $(
            '.parameter-dependent' +
            ':not(.no-display)' +
            ':not(.noDisplay)' +
            ':not(.default-variant)'
        ).first();

        if ($visible.length) {
            var className =
                $visible.attr('class') || '';

            var classes =
                className.split(/\s+/);

            for (
                var i = 0;
                i < classes.length;
                i++
            ) {
                var match =
                    classes[i].match(
                        /^(\d+)-(\d+)$/
                    );

                if (!match) {
                    continue;
                }

                var visibleKey =
                    match[0];

                var visibleVariant =
                    variantData[visibleKey];

                if (
                    visibleVariant &&
                    visibleVariant.code
                ) {
                    return visibleVariant.code;
                }
            }
        }

        /*
         * 2. Jediná nebo automaticky předvybraná varianta:
         *
         * <select
         *   class="hidden-split-parameter"
         *   data-parameter-id="14">
         *   <option value="23237" selected>L</option>
         * </select>
         *
         * Z toho vytvoříme klíč "14-23237".
         */
        var $variantSelects =
            $('select.hidden-split-parameter');

        if ($variantSelects.length) {
            var selectedParts = [];
            var allValuesSelected = true;

            $variantSelects.each(function () {
                var $select = $(this);

                var parameterId =
                    $select.attr(
                        'data-parameter-id'
                    ) ||
                    String(
                        $select.attr('id') || ''
                    ).replace(
                        /^parameter-id-/,
                        ''
                    );

                var valueId =
                    $select.val();

                if (
                    !parameterId ||
                    !valueId
                ) {
                    allValuesSelected = false;
                    return false;
                }

                selectedParts.push({
                    parameterId:
                        String(parameterId),

                    valueId:
                        String(valueId)
                });
            });

            if (
                allValuesSelected &&
                selectedParts.length
            ) {
                /*
                 * Nejprve zkusíme přímý klíč.
                 * Pro jeden parametr to bude například:
                 * "14-23237"
                 */
                if (selectedParts.length === 1) {
                    var singleKey =
                        selectedParts[0].parameterId +
                        '-' +
                        selectedParts[0].valueId;

                    var singleVariant =
                        variantData[singleKey];

                    if (
                        singleVariant &&
                        singleVariant.code
                    ) {
                        return singleVariant.code;
                    }
                }

                /*
                 * Pro více parametrů nemusíme znát přesný formát
                 * složeného klíče, proto projdeme dostupná data
                 * a hledáme klíč obsahující všechny dvojice.
                 */
                var variantKeys =
                    Object.keys(variantData);

                for (
                    var keyIndex = 0;
                    keyIndex < variantKeys.length;
                    keyIndex++
                ) {
                    var variantKey =
                        variantKeys[keyIndex];

                    var containsAllParts =
                        selectedParts.every(
                            function (part) {
                                return variantKey.indexOf(
                                    part.parameterId +
                                    '-' +
                                    part.valueId
                                ) !== -1;
                            }
                        );

                    if (!containsAllParts) {
                        continue;
                    }

                    var selectedVariant =
                        variantData[variantKey];

                    if (
                        selectedVariant &&
                        selectedVariant.code
                    ) {
                        return selectedVariant.code;
                    }
                }
            }
        }

        /*
         * 3. Poslední fallback:
         * Pokud existuje právě jediná varianta v datech,
         * vrátíme její kód.
         */
        var availableVariants =
            Object.keys(variantData)
                .map(function (key) {
                    return variantData[key];
                })
                .filter(function (variant) {
                    return Boolean(
                        variant &&
                        variant.code
                    );
                });

        if (availableVariants.length === 1) {
            return availableVariants[0].code;
        }

        /*
         * Varianta zatím není jednoznačně určena.
         */
        return null;
    }

    /*
     * Produkt bez variant.
     */
    return (
        $(
            '#product-detail-form ' +
            '> span[itemprop="offers"] ' +
            '> meta[itemprop="sku"]'
        ).attr('content') ||

        $('meta[itemprop="sku"]')
            .first()
            .attr('content') ||

        null
    );
}


    function mhPriceFetch() {
        var sku = getActiveSku();
        if (!sku) return;

        console.log('[mhPriceFetch] Aktivní SKU: ' + sku);

        $.ajax({
            url:         'https://php.shopcode.cz/api/outdoormarket/api-prices.php',
            method:      'POST',
            contentType: 'application/json',
            dataType:    'json',
            data:        JSON.stringify({ codes: [sku] }),
        })
        .done(function (response) {
            if (response.status !== 'ok') return;

            $.each(response.data, function (i, item) {
                console.log('[mhPriceFetch] SKU: ' + item.item_id + ', cena: ' + item.common_price);
                 $('.p-final-price-wrapper small.lowerPrice').remove();
                $('.p-final-price-wrapper').prepend('<small class="lowerPrice" style="    display: block;">Nejnižší cena za poslední 30 dní od poskytnutí slevy: '+Number(item.common_price).ShoptetFormatAsCurrency()+'</small>')
                // $('[data-lower-price]').attr('data-lower-price', Number(item.common_price).ShoptetFormatAsCurrency());
            });
        })
        .fail(function (xhr, status, error) {
            console.error('[mhPriceFetch] AJAX chyba: ' + status + ' – ' + error);
        });
    }

    if ($('.variant-list').length) {
        // Produkt s variantami – spustí se při každé změně varianty
        document.addEventListener('ShoptetVariantAvailable', function () {
            mhPriceFetch();
        });
    } else {
        // Produkt bez variant – spustí se po načtení stránky
        $(document).ready(function () {
            mhPriceFetch();
        });
        document.addEventListener('ShoptetDOMContentLoaded', function () {
            mhPriceFetch();
        });
    }

}